import React from 'react';

import { PageContentBlock } from 'api/cms';
import { PublicPage } from 'api/website';
import { blockMappingByType } from 'cms/blocks/blockMappingByType';

type Props = {
  content: PublicPage;
  block: PageContentBlock;
  blockIndex: number;
};

export function AmpContentBlock({ content, block, blockIndex }: Props) {
  if (!blockMappingByType[block.type]) {
    return null;
  }

  const { AmpComponent } = blockMappingByType[block.type];
  if (!AmpComponent) return null;

  return (
    <AmpComponent
      content={content}
      blockId={block.id}
      blockIndex={blockIndex}
      data={block.data}
      context="amp"
      pageUpdated={content.updated}
    />
  );
}
